import {
    initSnowplowTracker,
    triggerSnowplowPageViewEvent,
} from '@themuse/snowplow-js-client';
import React from 'react';

export enum PAGE_VIEW_SECTIONS {
    ARTICLES = 'articles',
    ADVICE = 'advice',
    OTHER = 'other',
}

export enum PAGE_VIEW_TYPES {
    SINGLE_CONTENT = 'single_content',
    COLLECTION = 'collection',
    CONTENT = 'content',
    ENTITY = 'entity',
    FEED = 'feed',
    LANDING_PAGE = 'landing_page',
    MESSAGING = 'messaging',
    USER_INPUT = 'user_input',
    OTHER = 'other',
}

export const SnowplowPageViewTracker = (props: {
    pageCompanyId?: number | null;
    pageEntityId?: string | null;
    pageSection?: string | null;
    pageTab?: number | null;
    pageType?: string;
    userId?: number | null;
}) => {
    const {
        pageCompanyId = null,
        pageEntityId = null,
        pageSection = PAGE_VIEW_SECTIONS.OTHER,
        pageTab = null,
        pageType = PAGE_VIEW_TYPES.OTHER,
        userId = null,
    } = props;
    React.useEffect(() => {
        const snowplowCollector = process.env.NEXT_PUBLIC_SNOWPLOW_COLLECTOR_ENDPOINT;
        const snowplowAppId = process.env.NEXT_PUBLIC_SNOWPLOW_APP_ID;

        if (!snowplowCollector || !snowplowAppId) {
            console.warn(
                'Snow plow Collector or Id not set up',
                snowplowCollector,
                snowplowAppId
            );
            return;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            sp_page_sponsor_id: String(pageCompanyId),
            sp_page_entity_id: String(pageEntityId),
            sp_page_is_external: false,
            sp_page_section: pageSection,
            sp_page_tab: pageTab,
            sp_page_type: pageType,
            sp_user_id: userId,
            sp_user_logged_in: !!userId,
        });

        initSnowplowTracker(snowplowCollector, snowplowAppId);
        triggerSnowplowPageViewEvent();
    }, []);

    return null;
};
